import { EnhancedRouteProps } from '../../../../routes/Enhanced/Enhanced.route';
import Members from './pages/Members';

export default [
  {
    index: true,
    element: Members,
  },
] as Array<EnhancedRouteProps>;
